export const ConfigurationsFormSchema = (t: Function) => {
  return {
    key: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[a-zA-Z0-9]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    description: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 512,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    type: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    value: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 2048,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    status: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
    releaseversion: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
  };
};

export const InitialBankFormSchema = (t: Function) => {
  return {
    languages: {
      required: true,
    },
    defaultLanguage: {
      required: true,
    },
    decimalGroup: {
      required: true,
    },
    decimalNumber: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    decimalSeparator: {
      required: true,
    },
    defaultCurrency: {
      required: true,
    },
  };
};

export const SecurityFormSchema = (t: Function) => {
  return {
    "default.security.secondFactorMinimumLenght": {
      required: true,
    },
    "default.security.secondFactorIsEnabledResendButton": {
      required: true,
    },
    "default.security.secondFactorIsAutomaticTrigger": {
      required: true,
    },
    "default.security.enableRegistrationAtLogin": {
      required: true,
    },
    "default.security.secondFactorResendTime": {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 2,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    "default.security.secondFactorIsNumeric": {
      required: true,
    },
  };
};

export const MappedFieldSchema = (t: Function) => {
  return {
    name: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^+'"*-;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 50,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^+'"*-;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]/,
    },
    description: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^+'"*-;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 512,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-'"*+;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    descriptionvs2: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^+'"*-;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 512,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-'"*+;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    labelkey: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
    },
    descriptionlabelkey: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 2048,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    jsonpath: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 1024,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    extrajsonpath: {
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 1024,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    serviceapi: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    datatype: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    releaseversion: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
  };
};

export const QuickLinksFormSchema = (t: Function) => {
  return {
    name: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^'"*-+;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 50,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^'"*-+;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    labelkey: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^'"*+;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^'"*+;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    iconname: {

      maxLength: {
        value: 2048,
        message: t("GlobalConfigurations.generalErrorMessage"),
      }
      
    },
    linkto: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      // pattern: {
      //   value: /^[\S][^'"*+;|?&=<>()%{}@\u005B\u005C\u005D]{0}/,
      //   message: t("GlobalConfigurations.generalErrorMessage"),
      // },
      maxLength: {
        value: 1024,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      // keyfilter: /^[^'"*+;|?&=<>()%{}@\u005B\u005C\u005D]*$/,
    },
    fieldorder: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 2,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[0-9]*$/,
    },
    category: {
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 2,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[0-9]*$/,
    },
    status: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
    releaseversion: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
    description: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^'"*-+;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 512,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^'"*-+;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    descriptionvs2: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^'"*-+;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 512,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^'"*-+;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    type: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
    level: {
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 2,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[0-9]*$/,
    },
  };
};

export const TranslationsSchema = (t: Function) => {
  return {
    key: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[a-zA-Z0-9-_.]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    description: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 512,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    translationenglishid: {
      required: true,
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    envalue: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 2048,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    translationspanishid: {
      required: true,
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    esvalue: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 2048,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    type: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    widgets: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
    releaseversion: {
      required: true,
    },
  };
};

export const ProductsFormSchema = (t: Function) => {
  return {
    name: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 50,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    nameinapi: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 50,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]+$/,
    },
    labelkey: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]+$/,
    },
    releaseversion: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
  };
};

export const TransactionsFormSchema = (t: Function) => {
  return {
    name: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 50,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    systemfunction: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]+$/,
    },
    labelkey: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]+$/,
    },
    wildcardcode: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 9,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[0-9]*$/
    },
    authorizationflowname: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]+$/,
    },
    isbatch: {
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    releaseversion: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
    fieldorder: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 2,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[0-9]*$/,
    },
  };
};

export const CampaignCreatorSchema = (t: Function) => {
  return {
    advertiseid: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 9,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[0-9]*$/,
    },
    type: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    properties: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 2048,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
  };
};

export const WidgetCreatorSchema = (t: Function) => {
  return {
    widgetname: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 50,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    releaseversion: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    description: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^+'"*;|?&=<>()%{}:-@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 512,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    descriptionvs2: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^+'"*;|?&=<>()%{}:-@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 512,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^+'"*;|?&=<>()%{}:-@\u002F\u005B\u005C\u005D]/,
    },
  };
};

export const AgentsFormSchema = (t: Function) => {
  return {
    name: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 50,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]+$/,
    },
    version: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 10,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]+$/,
    },
    url: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^+'"*;|?&=<>()%{}@\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 1024,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^+'"*;|?&=<>()%{}@\u005B\u005C\u005D]+$/,
    },
    publickey: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 2048,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^+'"*;|?&=<>()%{}@\u005B\u005C\u005D]+$/,
    },
    status: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
  };
};

export const ProdGeneralInfoFormSchema = (t: Function) => {
  return {
    name: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 50,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    labelkey: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]+$/,
    },
    fieldorder: {
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 2,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[0-9]*$/,
    },
    cardType: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 128,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]+$/,
    },
    iconName: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]+$/,
    },
    cardIcon: {
      pattern: {
        value: /^[\S][^+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]+$/,
    },
    productNumberPosition: {
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 128,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]+$/,
    },
    logoImage: {
      pattern: {
        value: /^[\S][^+'"*;|?&=<>()%{}@\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 1024,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^+'"*;|?&=<>()%{}@\u005B\u005C\u005D]+$/,
    },
    cardBackgroundImage: {
      pattern: {
        value: /^[\S][^+'"*;|?&=<>()%{}@\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 1024,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^+'"*;|?&=<>()%{}@\u005B\u005C\u005D]+$/,
    },
    minimumProductsToConsolidate: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 2,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[0-9]*$/,
    },
    getMoreProductsLink: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^+'"*;|?&=<>()%{}@\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 1024,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^+'"*;|?&=<>()%{}@\u005B\u005C\u005D]+$/,
    },
    transactionRecordsPaginationNumber: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 3,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[0-9]*$/,
    },
  };
};

export const ApplicationCreatorSchema = (t: Function) => {
  return {
    name: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 20,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[0-9A-Za-z_Á-ÿ\s]*$/,
    },
    status: {
      required: {
        value: true,
        message: "GlobalConfigurations.requiredErrorMessage",
      }
    },
    segment: {
      required: {
        value: true,
        message: "GlobalConfigurations.requiredErrorMessage",
      }
    },
    currentversion: {
      required: {
        value: true,
        message: "GlobalConfigurations.requiredErrorMessage",
      },
    }
  };
};

export const TrxGeneralInfoFormSchema = (t: Function) => {
  return {
    name: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 50,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    labelkey: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]+$/,
    },
    wildcardcode: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 9,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[0-9]*$/,
    },
    systemfunction: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]+$/,
    },
    authorizationflowname: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]+$/,
    },
    fieldorder: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 2,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[0-9]*$/,
    },
    icon: {
      pattern: {
        value: /^[\S][^+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]+$/,
    },
  };
};

export const EnvClonerSchema = (t: Function) => {
  return {
    clonename: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 150,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    segment: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    tenant: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    environment: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
  };
};

export const EnvCreatorSchema = (t: Function) => {
  return {
    name: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[a-zA-Z0-9]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 40,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[a-zA-Z0-9]*$/,
    },
    agent: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    status: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    cacheurl: {
      maxLength: {
        value: 512,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    cacheapikey: {
      maxLength: {
        value: 128,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
  };
};

export const TenantCreatorSchema = (t: Function) => {
  return {
    name: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 50,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    alias: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 20,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    shortname: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 20,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    primarycolor: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[^g-zG-Z-+'"*#;|?&=<>()%{}:@°!$¿¡¨_.,~«≠ºª•¶§∞¢£“´¬–…ñÑáäéëíïóöúüÁÄÉËÍÏÓÖÚÜ\s\u002F\u005B\u005C\u005D]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 6,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^g-zG-Z-+'"*#;|?&=<>()%{}:@°!$¿¡¨_.,~«≠ºª•¶§∞¢£“´¬–…ñÑáäéëíïóöúüÁÄÉËÍÏÓÖÚÜ\s\u002F\u005B\u005C\u005D]*$/,
    },
    secondarycolor: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[^g-zG-Z-+'"*#;|?&=<>()%{}:@°!$¿¡¨_.,~«≠ºª•¶§∞¢£“´¬–…ñÑáäéëíïóöúüÁÄÉËÍÏÓÖÚÜ\s\u002F\u005B\u005C\u005D]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 6,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^g-zG-Z-+'"*#;|?&=<>()%{}:@°!$¿¡¨_.,~«≠ºª•¶§∞¢£“´¬–…ñÑáäéëíïóöúüÁÄÉËÍÏÓÖÚÜ\s\u002F\u005B\u005C\u005D]*$/,
    },
    logo: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
    isotypelogo: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
    guid: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      }
    },
    tenantcode: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 50,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
  };
};

export const IMGeneralInfoFormSchema = (t: Function) => {
  return {
    providerDomain: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^+'"*;|?&=<>()%{}@\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 1024,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^+'"*;|?&=<>()%{}@\u005B\u005C\u005D]*$/,
    },
    companyId: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 20,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    groupId: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 20,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    clientId: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 20,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    urlMainJs: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^+'"*;|?&=<>()%{}@\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 1024,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^+'"*;|?&=<>()%{}@\u005B\u005C\u005D]*$/,
    },
  };
};

export const VersionCreatorSchema = (t: Function) => {
  return {
    number: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[0-9A-Za-z.Á-ÿ\s]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 10,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[0-9A-Za-z.Á-ÿ\s]*$/,
    },
    name: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[0-9A-Za-z.Á-ÿ\s]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 10,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[0-9A-Za-z.Á-ÿ\s]*$/,
    },
    description: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 50,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    descriptionvs2: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 50,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
  };
};

export const TransactionPropCreatorSchema = (t: Function) => {
  return {
    key: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[a-zA-Z0-9]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[a-zA-Z0-9]*$/,
    },
    labelkey: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    description: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 512,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]/,
    },
    descriptionvs2: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 512,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]/,
    },
    defaultvalue: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      maxLength: {
        value: 1024,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    defaultvalueNumeric: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      maxLength: {
        value: 1024,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[0-9]/,
    },
    isdefaultforall: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
    type: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[a-zA-Z0-9.]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    usagelist: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
    usagelistv2: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
    releaseversion: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
  };
};

export const PermissionsFormSchema = (t: Function) => {
  return {
    functionalityId: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      }
    },
    privilegeId: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      }
    },
    protocolId: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      }
    },
    port: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 5,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[0-9]/,
    },
    methodId: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      }
    },
    pagePath: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 1024,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    servicePath: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 1024,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    expeditionDate: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    expirationDate: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    status: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
  };
};

export const FunctionalitiesFormSchema = (t: Function) => {
  return {
    key: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 50,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]+$/,
    },
    code: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 10,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[0-9A-Za-z-_Á-ÿ\s]*$/,
    },
    keyLabelDescription: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 512,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]+$/,
    },
    parentId: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    categoryId: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    keyLabel: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 1024,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    expeditionDate: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    expirationDate: {
      required: {
        value: false,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    status: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    isAdministrative: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      }
    },
  };
};

export const UsersSchema = (t: Function) => {
  return {
    firstName: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^+'"*-;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 25,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    lastName: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^+'"*-;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 25,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    email: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][a-zA-Z0-9-_.]+@[\S][a-zA-Z0-9-_.]+\.[\S][a-zA-Z0-9-_.]+$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 6,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 80,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^+'"*;|?&=<>()%{}:\u002F\u005B\u005C\u005D]*$/,
    },
    mainEmail: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][a-zA-Z0-9-_.]+@[\S][a-zA-Z0-9-_.]+\.[\S][a-zA-Z0-9-_.]+$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 6,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 80,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^+'"*;|?&=<>()%{}:\u002F\u005B\u005C\u005D]*$/,
    },
    secondaryEmail: {
      pattern: {
        value: /^[\S][a-zA-Z0-9-_.]+@[\S][a-zA-Z0-9-_.]+\.[\S][a-zA-Z0-9-_.]+$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 6,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 80,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^+'"*;|?&=<>()%{}:\u002F\u005B\u005C\u005D]*$/,
    },
  };
};

export const UsersSchemaFilter = (t: Function) => {
  return {
    firstName: {
      pattern: {
        value: /^[\S][^+'"*-;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 3,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 100,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    lastName: {
      pattern: {
        value: /^[\S][^+'"*-;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 3,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 100,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    email: {
      minLength: {
        value: 3,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 80,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^+'"~!,#$^*;|?&=<>()%{}:\u002F\u005B\u005C\u005D]*$/,
    },
    secondaryEmail: {
      pattern: {
        value: /^[\S][a-zA-Z0-9-_.]+@[\S][a-zA-Z0-9-_.]+\.[\S][a-zA-Z0-9-_.]+$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 3,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 80,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^+'"*;|?&=<>()%{}:\u002F\u005B\u005C\u005D]*$/,
    },
    mobile: {
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 18,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
  };
};

export const ConsoleTranslationsSchema = (t: Function) => {
  return {
    key: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[a-zA-Z0-9_-]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[a-zA-Z0-9_-]*$/,
    },
    type: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
    translationlanguage: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
    translationvalue: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 2048,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    functionality: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
    releaseversion: {
      required: true,
    },
  };
};

export const TenantSchemaFilter = (t: Function) => {
  return {
    name: {
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 50,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    alias: {
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 20,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    shortname: {
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 20,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
  };
};

export const PointsServiceSchema = (t: Function) => {
  return {
    name: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][a-zA-Z0-9_ñÑáéíóúÁËÍÓÚ\s]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 80,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@°!#$¿¡¨.,~«≠ºª•¶§∞¢£“¡¬–…äëïöüÄËÏÖÜ\u002F\u005B\u005C\u005D]*$/,
    },
    code: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[a-zA-Z0-9\s\[\]]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 30,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@°!#$¿¡¨_.,~«≠ºª•¶§∞¢£“¡¬–…ñÑáäéëíïóöúüÁÄÉËÍÏÓÖÚÜ\s\u002F\u005B\u005C\u005D]*$/,
    },
    description: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][a-zA-Z0-9_ñÑáéíóúÁËÍÓÚ\s]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 255,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@°!#$¿¡¨.,~«≠ºª•¶§∞¢£“¡¬–…äëïöüÄËÏÖÜ\u002F\u005B\u005C\u005D]*$/,
    },
  };
};

export const PointsMasterSchema = (t: Function) => {
  return {
    name: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][a-zA-Z0-9_ñÑáéíóúÁËÍÓÚ\s]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 80,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@°!#$¿¡¨.,~«≠ºª•¶§∞¢£“¡¬–…äëïöüÄËÏÖÜ\u002F\u005B\u005C\u005D]*$/,
    },
    code: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[a-zA-Z0-9\s\[\]]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 30,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@°!#$¿¡¨_.,~«≠ºª•¶§∞¢£“¡¬–…ñÑáäéëíïóöúüÁÄÉËÍÏÓÖÚÜ\s\u002F\u005B\u005C\u005D]*$/,
    },
    description: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][a-zA-Z0-9_ñÑáéíóúÁËÍÓÚ\s]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 255,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@°!#$¿¡¨.,~«≠ºª•¶§∞¢£“¡¬–…äëïöüÄËÏÖÜ\u002F\u005B\u005C\u005D]*$/,
    },
  };
};

export const ConsoleTranslationsImportSchema = (t: Function) => {
  return {
    functionality: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[a-zA-Z0-9,".\[\]]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 2048,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    key: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[a-zA-Z0-9-_]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    key_import: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[a-zA-Z0-9-_.]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    type: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[a-zA-Z0-9-_]*$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 512,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    description: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 512,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    envalue: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 2048,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    esvalue: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 2048,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
  };
};

export const PointsOfAttentionFormSchema = (t: Function) => {
  return {
    name: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|¿?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 80,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|¿?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    phone: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 3,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 40,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter:  /^[0-9]*$/,
    },
    extensionNumber: {
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 5,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[0-9]*$/,
    },
    code: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@%.,°_?¿=&#!$¡¬“£¢∞§¶•ªº≠«–…´\s\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 60,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@%.,°_?¿=&#!$¡¬“£¢∞§¶•ªº≠«–…´\s\u002F\u005B\u005C\u005D]+$/,
    },
    observation: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|¿?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 255,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|¿?&=<>()%{}:@\u002F\u005B\u005C\u005D]+$/,
    },
    address: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 80,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^+'"*;|?&=<>()%{}:@¿_\u002F\u005B\u005C\u005D]+$/,
    },
    latitude: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^-?([0-8]?[0-9]|90)(\.[0-9]{1,198})$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 200,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[0-9.-]*$/,
    },
    longitude: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^-?([0-8]?[0-9]|90)(\.[0-9]{1,198})$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 200,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[0-9.-]*$/,
    },
    country: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    department: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    city: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      minLength: {
        value: 1,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
  };
};

export const ProtocolsFormSchema = (t: Function) => {
  return {
    name: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 50,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    status: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
    description: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 512,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    newname: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 50,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
  };
};

export const RolesFormSchema = (t: Function) => {
  return {
    name: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 50,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    newname: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 50,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    description: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^[\S][^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]{0}/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      maxLength: {
        value: 512,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
      keyfilter: /^[^-+'"*;|?&=<>()%{}:@\u002F\u005B\u005C\u005D]*$/,
    },
    status: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
      pattern: {
        value: /^(.*\S.*)$/,
        message: t("GlobalConfigurations.generalErrorMessage"),
      },
    },
  };
};

export const AuditReportFormSchema = (t: Function) => {
  return {
    tenant: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
    name: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
    role: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
    functionality: {
      required: {
        value: true,
        message: t("GlobalConfigurations.requiredErrorMessage"),
      },
    },
  };
};
